import { render, staticRenderFns } from "./batch-payment-list.vue?vue&type=template&id=ef2559b4&"
import script from "./batch-payment-list.vue?vue&type=script&lang=js&"
export * from "./batch-payment-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports